import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import DOMPurify from "dompurify";
import { SourceCodeEditor } from "components/common";
const EditorStyles = styled.div`
  & .ace_editor {
    width: ${({ $width }) => $width};
  }

  & .ace_cursor {
    border-color: ${({ theme }) => theme.colors.text.primary};
  }
`;
function MDBaseEditor({
  autoFocus = false,
  value,
  onChange,
  id = "md-editor",
  readOnly = false,
  height = 200,
  width = "100%",
  onBlur = void 0
}) {
  const handleOnBlur = useCallback(() => {
    const sanitizedValue = DOMPurify.sanitize(
      // Remove dangerous HTML
      DOMPurify.sanitize(value, { USE_PROFILES: { html: false } })
    );
    if (onBlur) onBlur(sanitizedValue);
    else onChange(sanitizedValue);
  }, [onBlur, onChange, value]);
  return /* @__PURE__ */ React.createElement(EditorStyles, { $width: width }, /* @__PURE__ */ React.createElement(
    SourceCodeEditor,
    {
      focus: autoFocus,
      id,
      mode: "markdown",
      theme: "light",
      toolbar: false,
      resizable: false,
      readOnly,
      height,
      value,
      onChange,
      onBlur: handleOnBlur,
      onPaste: handleOnBlur
    }
  ));
}
export default MDBaseEditor;
